/**
 * The couple name guests should see: the site's displayName when it is
 * a real value, otherwise the internal site name. Empty strings and the
 * literal "null" (bad legacy data) count as unset.
 */
export function resolveDisplayName(
  displayName: string | null,
  name: string,
): string {
  if (typeof displayName !== "string") return name;
  const normalized = displayName.trim();
  if (!normalized || normalized.toLowerCase() === "null") return name;
  return normalized;
}
